import { ObjectEvent as olObjectEvent } from "ol/Object";
import olView, { FitOptions } from "ol/View";
import { Extent as olExtent } from "ol/extent";
import olProjection from "ol/proj/Projection";

export interface ViewProps {
  projection: olProjection;
  zoom?: number;
  center?: number[];
  minZoom?: number;
  maxZoom?: number;
  extent?: olExtent;
  onZoomChange?: (zoom: number) => void;
}

class View extends olView {
  private _onZoomChange?: (zoom: number) => void;

  constructor({
    projection,
    zoom,
    center,
    minZoom,
    maxZoom,
    extent,
    onZoomChange,
  }: ViewProps) {
    super({
      projection,
      zoom,
      center,
      minZoom,
      maxZoom,
      extent,
    });

    this._onZoomChange = onZoomChange;
    this.on("change:resolution", this.handleZoomChange);
  }

  get zoom(): number {
    return super.getZoom() as number;
  }

  set zoom(zoom: number) {
    super.setZoom(zoom);
  }

  get center(): number[] {
    return super.getCenter() as number[];
  }

  set center(center: number[]) {
    super.setCenter(center);
  }

  get projection(): olProjection {
    return super.getProjection();
  }

  get minZoom(): number {
    return super.getMinZoom();
  }

  set minZoom(minZoom: number) {
    super.setMinZoom(minZoom);
  }

  get maxZoom(): number {
    return super.getMaxZoom();
  }

  set maxZoom(maxZoom: number) {
    super.setMaxZoom(maxZoom);
  }

  get onViewChange(): ((zoom: number) => void) | undefined {
    return this._onZoomChange;
  }

  set onViewChange(onZoomChange: ((zoom: number) => void) | undefined) {
    this._onZoomChange = onZoomChange;
  }

  public fit(extent: olExtent, fitOptions?: FitOptions) {
    super.fit(extent, fitOptions);
  }

  handleZoomChange = (_: olObjectEvent) => {
    if (this._onZoomChange && this.zoom) this._onZoomChange(this.zoom);
  };
}

export default View;
